module.exports = __webpack_public_path__ + "img/gifiqr-kontakt-os.934a4af5.jpg";